export const appConfig = {
  storySlug: {
    referralRules: "rules-about-referral",
    aboutChallenge: "about-challenge",
    aboutProject: "about-project",
  },
  links: {
    privacy: "https://telegra.ph/OMMAVIY-OFERTA-05-13",
  },
  secret: {
    accessTokenKey: "access",
    refreshTokenKey: "refresh",
  },
  yandexAds: {
    fullscreenMobileId: "R-A-15495626-2",
    fullscreenMobileId2: "R-A-15495626-5",
    fullscreenDesktopId: "R-A-15495626-3",
    fullscreenDesktopId2: "R-A-15495626-4",
    bannerId: "R-A-15752151-1",
  },
  telegram: {
    baseUrl: "https://t.me/",
  },
  infiniteQueryLimit: 20,
};
